<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="Multi Table" name="first">
				<el-row>
					<el-col :span="24" style="margin-bottom: 40px;margin-top:30px;">
						<el-steps :active="step">
							<el-step title="The First step" description="Select Object"></el-step>
							<el-step title="The Second step" description="Select Keys"></el-step>
							<el-step title="The Third step" description="Select Conditions"></el-step>
							<el-step title="The Fourth step" description="Select Display Column"></el-step>
						</el-steps>
					</el-col>
					<el-col :span="24" v-if="step == 0">
						<el-form label-width="160px">
							<el-form-item label="Schema">
								<el-select v-model="form.sSchema" style="width:600px;" placeholder="Select" @change="change1">
									<el-option v-for="(item, index) in options" :key="index" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Table" v-for="(item, index) in form.table" :key="index" v-if="!!form.sSchema">
								<el-select v-model="item.nSelectId" style="width:600px;" placeholder="Select" @change="change2(item, index)">
									<el-option v-for="(item, index) in item.options" :key="index" :label="item.sName" :value="item.nSelectId"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0 && form.table.length < 3" v-on:click="addTable(form.table)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deleteTable(form.table, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" v-on:click="toStep1">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 2">
						<el-form label-width="160px">
							<el-form-item :label="'Table' + (index + 1)" v-for="(item, index) in form.table" :key="index">{{ item.sName }} ({{ item.sBie }})</el-form-item>
							<el-form-item v-for="(item, index) in form.keys" :key="index">
								<span>Table.1</span>
								<el-select v-model="item.sBie1" placeholder="" @change="change3(item, index)">
									<el-option v-if="panduanTable1(a, item)" v-for="(a, index) in form.table" :key="index" :label="a.sName + '(' + a.sBie + ')'" :value="a.sBie"></el-option>
								</el-select>
								<span>Table.2</span>
								<el-select v-model="item.sBie2" placeholder="" @change="change3(item, index)">
									<el-option v-if="a.sBie != item.sBie1" v-for="(a, index) in form.table" :key="index" :label="a.sName + '(' + a.sBie + ')'" :value="a.sBie"></el-option>
								</el-select>
								<span>Condition</span>
								<el-select v-model="item.selectKey" multiple placeholder="" style="width:400px;">
									<el-option v-for="(item, index) in item.keys" :key="index" :label="item.nSelect1Key + '=' + item.nSelect2Key" :value="item.nSelect1Key + '=' + item.nSelect2Key"></el-option>
								</el-select>
								<el-button type="button" v-if="index == 0" v-on:click="addkey(form.keys)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deletekey(form.keys, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="toStep0">The Prev Step</el-button>
								<el-button type="primary" v-on:click="toStep2">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 3">
						<el-form label-width="160px">
							<el-form-item :label="'Table' + (index + 1)" v-for="(item, index) in form.table" :key="'table' + index">
								{{ item.sName }} ({{ item.sBie }})
							</el-form-item>
							<el-form-item :label="'Keys' + (index + 1)" v-for="(item, index) in form.keys" :key="'s1' + index">
								<span v-for="(a, index) in item.selectKey" :key="'s2' + index">
									{{ item.sName1 }}({{ item.sBie1 }}).{{ stringArr(a, 0) }}={{ item.sName2 }}({{ item.sBie2 }}).{{ stringArr(a, 1) }}
									<span v-if="index != item.selectKey.length - 1">,</span>
								</span>
							</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="'s3' + index">
								<el-select v-model="item.sBie" placeholder="Select" clearable @change="change4(item, index)">
									<el-option v-for="(a, index) in form.table" :key="'table2' + index" :label="a.sName + '(' + a.sBie + ')'" :value="a.sBie"></el-option>
								</el-select>
								<el-select v-model="item.sColumnCode" @change="change5(item)" placeholder="Select">
									<el-option v-for="(a, index) in item.codes" :key="'s5' + index" :label="a.sColumnName" :value="a.sColumnCode"></el-option>
								</el-select>
								<el-select v-model="item.fuhao" placeholder="Select">
									<el-option v-for="a in options4" v-if="item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1" :key="a.id" :label="a.name" :value="a.id"></el-option>
								</el-select>
								<!-- <el-input
									style="width:400px;"
									v-if="
										item.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Event' ||
											item.sSelectName == 'T_EDW_FACT_Evtitm_Event_All' ||
											item.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Item'
									"
									v-model="item.value[0]"
									:placeholder="item.type"
								></el-input> -->
								<el-select v-model="item.value" style="width:400px;" multiple :multiple-limit="item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1" v-if="item.type != 'Datetime'&&item.sSelectName!='T_EDW_FACT_Evtitm_Event_All'" filterable remote reserve-keyword :placeholder="item.type" :data-id="index" :remote-method="querySearchAsync" :loading="loading">
									<el-option v-for="(item, index) in item.options" :key="index" :label="item" :value="item"></el-option>
								</el-select>
								<el-input v-model="item.value" v-else-if="item.type != 'Datetime'&&item.sSelectName=='T_EDW_FACT_Evtitm_Event_All'" style="width:400px;"></el-input>
								<el-date-picker v-else="item.type == 'Datetime'" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="padding:0;" prefix-icon="xxx" v-model="item.value[0]" type="datetime" :placeholder="item.type"></el-date-picker>
								<el-button type="button" v-if="index == 0" v-on:click="addList(form.sSelectFilter)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deleteList(form.sSelectFilter, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="toStep1">The Prev Step</el-button>
								<el-button type="primary" v-on:click="toStep3">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 5">
						<el-form label-width="400px">
							<el-form-item :label="'Table' + (index + 1)" v-for="(item, index) in form.table" :key="'aa1' + index">{{ item.sName }} ({{ item.sBie }})</el-form-item>
							<el-form-item :label="'Keys' + (index + 1)" v-for="(item, index) in form.keys" :key="'aa2' + index">
								<span v-for="(a, index) in item.selectKey" :key="'aa3' + index">
									{{ item.sName1 }}({{ item.sBie1 }}).{{ stringArr(a, 0) }}={{ item.sName2 }}({{ item.sBie2 }}).{{ stringArr(a, 1) }}
									<span v-if="index != item.selectKey.length - 1">,</span>
								</span>
							</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="'aa4' + index">
								<span class="span-label">{{ item.sName }}({{ item.sBie }}).{{ item.sColumnName }}</span>
								<label>{{ item.fuhao }}</label>
								<span class="span-label">{{ arrToString(item.value) }}</span>
							</el-form-item>
							<el-form-item v-for="(item, index) in form.sSelectFieldName" :label="item.sNameAll + '(' + item.sBie + ')' + '.Columns'" :key="'a1' + index">
								<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange(item)">全选</el-checkbox>
								<div style="margin: 15px 0;"></div>
								<el-checkbox-group v-model="item.value" @change="handleCheckedCitiesChange">
									<el-checkbox v-for="(a, index2) in item.options" :label="a.sColumnCode" :key="index + '-' + index2">{{ a.sColumnName }}</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="toStep2">The Prev Step</el-button>
								<el-button type="primary" v-on:click="save2">OK</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<el-dialog title="Display result" :visible.sync="dialogVisible" width="80%">
					<div style="font-size: 20px;" v-if="count < 1000000">
						<label>Row Count.</label>
						<span class="span-label">{{ count }}</span>
						<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'UnDisplay' : 'Display' }}</el-button>
						<el-button v-on:click="addDownLoad">
							Download
							<span v-if="timer > 0">({{ timer }})</span>
						</el-button>
					</div>
					<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
						<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
							<el-table-column width="200" v-for="(item,index) in displayArr" :key="index" :formatter="timeFormatter" :prop="item" :label="item"></el-table-column>
						</el-table>
					</div>
					<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
						<h2>
							<label>Row Count.</label>
							<span class="span-label">{{ count }}</span>
							Too much data,unable to export!
						</h2>
					</div>
					<!--<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
					</span>-->
				</el-dialog>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
	import {
		getSchemaNameList,
		getDynamicSQL,
		getTableRelevanceListBySelectList,
		getTableRelevanceList,
		addDownloadExport,
		addSelectView,
		getDatabaseInfoList,
		getSelectThirdTableList,
		getSelectSecondTableList,
		getSelectList,
		getSelectColumnList,
		getDynamicColumnList,
		selectExColumnValueBynSelectId,
		selectColumnValueBynSelectId
	} from '../../api/api';
	import util from '../../api/util.js';
	export default {
		data() {
			return {
				step: 0,
				form: {
					sSchema: "",
					table: [{
						sName: '',
						sBie: '',
						sSchemaName: '',
						sSelectName: '',
						nSelectId: '',
						options: []
					}],
					keys: [],
					sSchema: "",
					sSelectFilter: [],
					sSelectFieldName: []
				},
				activeName: 'first',
				options: [],
				options4: [{
						id: 'in',
						name: '='
					},
					{
						id: '>',
						name: '>'
					},
					{
						id: '>=',
						name: '>='
					},
					{
						id: '<',
						name: '<'
					},
					{
						id: '<=',
						name: '<='
					},
					{
						id: 'not in',
						name: '!='
					}
				],
				options5: [],
				dialogVisible: false,
				loading: false,
				tableData: [],
				showListFlag: false,
				count: 0,
				sql: {
					table: '',
					ziduan: '',
					join: '',
					tiaojian: ''
				},
				favortFlag: false,
				displayArr: [],
				timer: 0
			};
		},
		mounted() {
			getDatabaseInfoList({
				currentPage: 1,
				pageSize: 9999
			}).then(res => {
				this.options = res.data;
			});
			//this.change1(this.form.table[0], 0);
		},
		methods: {
			panduanTable1(a, item) {
				if(a.sBie != item.sBie2) {
					if(this.form.keys.length == 1) {
						return true;
					} else {
						var one = this.form.keys[this.form.keys.length - 2];
						if(one.sBie1 == '') {
							return true;
						} else {
							if(a.sBie == one.sBie1 || a.sBie == one.sBie2) {
								return true;
							} else {
								return false;
							}
						}
					}
				} else {
					return false;
				}
			},
			timeFormatter(row, column) {
				var shuju = row[column.property];
				try {
					if(shuju.indexOf('T') > -1) {
						var times = new Date(shuju);
						if(times == 'Invalid Date') {
							return shuju;
						}
						return util.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
					} else {
						return shuju;
					}
				} catch(e) {
					return shuju;
				}
			},
			stringArr(str, index) {
				var arr = (str || '').split('=');
				try {
					return arr[index];
				} catch(e) {
					return 0;
				}
			},
			querySearchAsync(queryString) {
				this.options5 = [];
				var index = 0;
				try {
					var node = window.getSelection().focusNode.parentElement;
					index = node.getAttribute('data-id');
				} catch(e) {
					//TODO handle the exception
				}
				if(!this.form.sSelectFilter[index]['sColumnCode']) {
					this.$message.error('Please select the Condition Code');
					return;
				}
				if(queryString != '') {
					this.loading = true;
					selectColumnValueBynSelectId({
						nSelectId: this.form.sSelectFilter[index]['nSelectId'],
						sColumnCode: this.form.sSelectFilter[index]['sColumnCode']
					}).then(res => {
						if(res.data.length === 0) {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.form.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.form.sSelectFilter[index]['sSchemaName'],
								sSelectName: this.form.sSelectFilter[index]['sSelectName'],
								pageSize: 9999
							}).then(res => {
								var arr = [];
								for(var i = 0; i < res.data.length; i++) {
									arr.push(res.data[i][this.form.sSelectFilter[index]['sColumnCode']]);
								}
								this.loading = false;
								this.form.sSelectFilter[index].options = arr;

							});
						} else {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.form.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.form.sSelectFilter[index]['sSchemaName'],
								sSelectName: this.form.sSelectFilter[index]['sSelectName'],
								pageSize: 9999
							}).then(res2 => {
								var arr = [];
								for(var i = 0, len = res.data.length; i < len; i++) {
									for(var j = 0, len2 = res2.data.length; j < len2; j++) {
										if(res.data[i]['sColumnValue'] == res2.data[j][this.form.sSelectFilter[index]['sColumnCode']]) {
											arr.push(res.data[i]['sColumnValue'])
										}
									}
								}
								this.loading = false;
								this.form.sSelectFilter[index].options = arr;

							});
						}
					})

				}
			},
			addTable(item) {
				if(!item[0].nSelectId) {
					this.$message('Select Table');
					return;
				}
				var obj = {
					sName: '',
					sBie: '',
					sSchemaName: item[0].sSchemaName,
					sSelectName: '',
					nSelectId: '',
					options: []
				};

				if(this.form.table.length == 1) {
					getSelectSecondTableList({
						nSelect1Id: this.form.table[0].nSelectId,
						sSchemaName: this.form.table[0].sSchemaName
					}).then(res => {
						//obj.options = this.form.table[0].options;
						obj.options = res.data;
						item.push(obj);
					});
				} else if(this.form.table.length == 2) {
					if(!item[1].nSelectId) {
						this.$message('Select Table');
						return;
					}
					getSelectThirdTableList({
						nSelect1Id: this.form.table[0].nSelectId,
						nSelect2Id: this.form.table[1].nSelectId
					}).then(res => {
						obj.options = res.data;
						item.push(obj);
					});
				}
			},
			deleteTable(item, index) {
				item.splice(index, 1);
				try {
					this.form.sSelectFieldName.splice(index, 1);
				} catch(e) {}
			},
			addList(item) {
				item.push({
					nSelectId: '',
					codes: [],
					sName: '',
					sBie: '',
					sSchemaName: '',
					sSelectName: '',
					sColumnName: '',
					sColumnCode: '',
					fuhao: '',
					options: [],
					value: [],
					type: ''
				});
			},
			deleteList(item, index) {
				item.splice(index, 1);
			},
			addkey(item) {
				item.push({
					table1: '',
					sName1: '',
					sBie1: '',
					sSchema1Name: '',
					sSelect1Name: '',
					table2: '',
					sName2: '',
					sBie2: '',
					sSchema2Name: '',
					sSelect2Name: '',
					selectKey: [],
					keys: []
				});
			},
			deletekey(item, index) {
				item.splice(index, 1);
			},
			toStep0() {
				this.step = 0;
			},
			toStep1() {
				for(var i = this.form.table.length - 1; i >= 0; i--) {
					if(!this.form.table[i]['nSelectId']) {
						this.form.table.splice(i, 1);
					}
				}
				if(this.form.table.length < 2) {
					this.$message.error('Please select the minimum two table');
					return;
				}
				if(this.form.keys.length == 0) {
					this.form.keys = [{
						table1: '',
						sName1: '',
						sBie1: '',
						sSchema1Name: '',
						sSelect1Name: '',
						table2: '',
						sName2: '',
						sBie2: '',
						sSchema2Name: '',
						sSelect2Name: '',
						selectKey: [],
						keys: []
					}];
				}
				this.step = 2;
			},
			toStep2() {
				var flag = false;
				var obj = {};
				var index = 0;
				for(var i = 0; i < this.form.keys.length; i++) {
					if(this.form.keys[i]['selectKey'].length == 0) {
						this.$message.error('Please select the table keys');
						flag = true;
						return;
					}
					if(!obj[this.form.keys[i]['table1']]) {
						obj[this.form.keys[i]['table1']] = 1;
						index++;
					}
					if(!obj[this.form.keys[i]['table2']]) {
						obj[this.form.keys[i]['table2']] = 1;
						index++;
					}
				}
				// 			if (index != this.form.table.length) {
				// 				this.$message.error('Please select the min relation');
				// 				return;
				// 			}

				if(flag == true) {
					return;
				}
				if(this.form.sSelectFilter.length == 0) {
					this.form.sSelectFilter = [{
						nSelectId: '',
						codes: [],
						sName: '',
						sBie: '',
						sSchemaName: '',
						sSelectName: '',
						sColumnName: '',
						sColumnCode: '',
						fuhao: '',
						options: [],
						value: [],
						type: ''
					}];
				}
				this.step = 3;
			},
			toStep3() {

				if(this.form.sSelectFilter.length == 1) {
					//当数组只有一个的时候 切都不存在的时候
					if(!this.form.sSelectFilter[0]['sColumnCode'] && !this.form.sSelectFilter[0]['fuhao'] && this.form.sSelectFilter[0]['value'].length == 0) {
						this.form.sSelectFilter.splice(0, 1);
						this.step = 5;
						return;
					}
				}
				var flag = false;
				for(var i = 0; i < this.form.sSelectFilter.length; i++) {
					if(!this.form.sSelectFilter[i]['sColumnCode']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(!this.form.sSelectFilter[i]['fuhao']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(this.form.sSelectFilter[i]['value'].length == 0) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
				}
				this.step = 5;
			},
			save2() {
				if(this.form.sSelectFieldName.length == 0) {
					this.$message.error('Please select the Columns');
					return;
				}
				this.$prompt('Enter file name', 'Tips', {
						confirmButtonText: 'Confirm',
						cancelButtonText: 'Cancel',
						inputPattern: /\S/,
						inputErrorMessage: 'Enter file name'
					})
					.then(({
						value
					}) => {
						var sqlDongGArr = [];
						this.form.table.forEach(one => {
							sqlDongGArr.push(selectExColumnValueBynSelectId({
								nSelectId: one.nSelectId
							}))
						});
						Promise.all(sqlDongGArr).then(res => {
							var duoyuanarr = []
							res.forEach((one, index) => {
								one.data.forEach(two => {
									duoyuanarr.push(
										this.form.table[index]['sBie'] +
										'.' +
										two.sColumnCode +
										' in(N' +
										two.sColumnValue +
										')'
									);
								})
							})
							//							res.forEach((one, index) => {
							//								var duoyuanarr2 = [];
							//								one.data.forEach(two => {
							//									duoyuanarr2.push(
							//										one.sColumnName +
							//										'.' +
							//										one.sColumnCode +
							//										' in(' +
							//										one.sColumnValue +
							//										')'
							//									);
							//									duoyuanarr.push(duoyuanarr2)
							//								})
							//							})
							//debugger
							this.pinjiesql(duoyuanarr);
							addDownloadExport({
								sSchema: this.form.sSchema,
								sSelectName: this.sql.table,
								sSelectFieldName: this.sql.ziduan,
								sSelectFilter: this.sql.tiaojian,
								sFileName: value + '.csv',
								sContent: JSON.stringify(this.form),
								sFavorite: 0,
								nType: 2,
								sStatus: 0
							}).then(res => {
								this.$message('download success！');
							});

						})

					})
					.catch(() => {});

			},
			save() {
				if(this.form.sSelectFieldName.length == 0) {
					this.$message.error('Please select the Columns');
					return;
				}

				var arr = [];
				var displayArr = [];
				for(var i = 0; i < this.form.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.form.sSelectFieldName[i]['value'].length; j++) {
						arr.push(
							this.form.sSelectFieldName[i]['sBie'] +
							'.' +
							this.form.sSelectFieldName[i]['value'][j] +
							' as ' +
							this.form.sSelectFieldName[i]['sBie'] +
							'_' +
							this.form.sSelectFieldName[i]['value'][j]
						);
						displayArr.push(this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
					}
				}
				this.sql.ziduan = arr.join(',');

				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				var arr = [];
				for(var i = 0; i < this.form.sSelectFilter.length; i++) {
					if(this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.form.sSelectFilter[i]['sBie'] +
							'.' +
							this.form.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.form.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.form.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.form.sSelectFilter[i]['sBie'] +
								'.' +
								this.form.sSelectFilter[i]['sColumnCode'] +
								this.form.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.form.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}
				this.sql.tiaojian = arr.join(' and ');

				var arr = [];
				arr.push(this.form.keys[0]['sSchema1Name'] + '.' + this.form.keys[0]['sSelect1Name'] + ' ' + this.form.keys[0]['sBie1']);

				for(var i = 0; i < this.form.keys.length; i++) {
					var _arr = [];
					for(var j = 0; j < this.form.keys[i]['selectKey'].length; j++) {
						_arr.push(
							this.form.keys[i]['sBie1'] +
							'.' +
							this.stringArr(this.form.keys[i]['selectKey'][j], 0) +
							'=' +
							this.form.keys[i]['sBie2'] +
							'.' +
							this.stringArr(this.form.keys[i]['selectKey'][j], 1)
						);
					}

					arr.push(this.form.keys[i]['sSchema2Name'] + '.' + this.form.keys[i]['sSelect2Name'] + ' ' + this.form.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
				}
				this.sql.table = arr.join(' left join  ');
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				getDynamicSQL({
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sSchemaName: this.form.sSchema,
						currentPage: 1,
						pageSize: 100
					})
					.then(res => {
						loading.close();
						this.count = res.page.totalCount * 1;
						this.tableData = res.data;
						this.favortFlag = false;
						this.timer = 0;
						this.displayArr = displayArr;
						this.dialogVisible = true;
					})
					.catch(res => {
						loading.close();
					});
			},
			change1(item, index) {
				//if(index == 0) {
				getSelectList({
					currentPage: 1,
					nSelectType: 1,
					sSchema: this.form.sSchema,
					pageSize: 9999
				}).then(res => {
					this.form.table[0].options = res.data;
				});
				//}
			},
			change5(item) {
				for(var i = 0; i < item.codes.length; i++) {
					if(item.codes[i]['sColumnCode'] == item.sColumnCode) {
						item.type = item.codes[i]['sColumnType'];
						item.sColumnName = item.codes[i]['sColumnName'];
					}
				}
			},
			change4(item, index) {
				if(!!item.sBie) {
					for(var i = 0; i < this.form.table.length; i++) {
						if(this.form.table[i]['sBie'] == item.sBie) {
							item.sName = this.form.table[i]['sName'];
							item.sSchemaName = this.form.table[i]['sSchemaName'];
							item.sSelectName = this.form.table[i]['sSelectName'];
							item.nSelectId = this.form.table[i]['nSelectId'];
						}
					}
					//console.log(item);
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelectId,
						pageSize: 9999
					}).then(res => {
						item.codes = res.data;
						item.fuhao = '';
						item.sColumnCode = '';
						item.value = [];
						item.options = [];
					});
				} else {
					item.fuhao = '';
					item.codes = [];
					item.sColumnCode = '';
					item.value = [];
					item.options = [];
				}
			},
			change2(item, index) {
				//console.log(item);
				for(var i = 0; i < item.options.length; i++) {
					if(item.options[i]['nSelectId'] == item.nSelectId) {
						item.sSelectName = item.options[i]['sSelectName'];
						item.sSchemaName = item.options[i]['sSchemaName'];
						item.sName = item.options[i]['sName'];
						item.sBie = 'Table' + (index + 1);
					}
				}

				this.form.keys = [{
					table1: '',
					sName1: '',
					sBie1: '',
					sSchema1Name: '',
					sSelect1Name: '',
					table2: '',
					sName2: '',
					sBie2: '',
					sSchema2Name: '',
					sSelect2Name: '',
					selectKey: [],
					keys: []
				}];

				this.form.sSelectFilter = [{
					nSelectId: '',
					codes: [],
					sName: '',
					sBie: '',
					sSchemaName: '',
					sSelectName: '',
					sColumnName: '',
					sColumnCode: '',
					fuhao: '',
					options: [],
					value: [],
					type: ''
				}];

				if(index == 0) {
					getSelectSecondTableList({
						nSelect1Id: item.nSelectId,
						sSchemaName: item.sSchemaName
					}).then(res => {
						try {
							this.form.table[1]['nSelectId'] = '';

							//this.form.table[1].option = this.form.table[0].option;
							this.form.table[1].options = res.data;
							console.log(this.form);
						} catch(e) {
							//TODO handle the exception
						}
					});
				} else if(index == 1) {
					getSelectThirdTableList({
						nSelect1Id: this.form.table[0].nSelectId,
						nSelect2Id: this.form.table[1].nSelectId
					}).then(res => {
						try {
							this.form.table[2]['nSelectId'] = '';
							this.form.table[2].options = res.data;
						} catch(e) {
							//TODO handle the exception
						}
					});
				}

				if(index == 0) {
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelectId,
						pageSize: 9999
					}).then(res => {
						if(this.form.sSelectFieldName.length == 0) {
							this.form.sSelectFieldName.push({
								sNameAll: item.sName,
								sBie: item.sBie,
								sName: item.sSchemaName + '.' + item.sSelectName,
								checkAll: false,
								isIndeterminate: true,
								options: res.data,
								value: []
							});
						} else {
							this.$set(this.form.sSelectFieldName, 0, {
								sNameAll: item.sName,
								sBie: item.sBie,
								sName: item.sSchemaName + '.' + item.sSelectName,
								checkAll: false,
								isIndeterminate: true,
								options: res.data,
								value: []
							});
						}
					});
				} else if(index == 1) {
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelectId,
						pageSize: 9999
					}).then(res => {
						if(this.form.sSelectFieldName.length == 1) {
							this.form.sSelectFieldName.push({
								sNameAll: item.sName,
								sBie: item.sBie,
								sName: item.sSchemaName + '.' + item.sSelectName,
								checkAll: false,
								isIndeterminate: true,
								options: res.data,
								value: []
							});
						} else {
							this.$set(this.form.sSelectFieldName, 1, {
								sNameAll: item.sName,
								sBie: item.sBie,
								sName: item.sSchemaName + '.' + item.sSelectName,
								checkAll: false,
								isIndeterminate: true,
								options: res.data,
								value: []
							});
						}
					});
				} else if(index == 2) {
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelectId,
						pageSize: 9999
					}).then(res => {
						if(this.form.sSelectFieldName.length == 2) {
							this.form.sSelectFieldName.push({
								checkAll: false,
								sBie: item.sBie,
								isIndeterminate: true,
								options: res.data,
								sNameAll: item.sName,
								sName: item.sSchemaName + '.' + item.sSelectName,
								value: []
							});
						} else {
							this.$set(this.form.sSelectFieldName, 2, {
								sNameAll: item.sName,
								sBie: item.sBie,
								sName: item.sSchemaName + '.' + item.sSelectName,
								checkAll: false,
								isIndeterminate: true,
								options: res.data,
								value: []
							});
						}
					});
				}
			},
			change3(item, index) {
				console.log(item);
				if(!!item.sBie1 && !!item.sBie2) {
					for(var i = 0; i < this.form.table.length; i++) {
						if(this.form.table[i]['sBie'] == item.sBie1) {
							item.sSchema1Name = this.form.table[i]['sSchemaName'];
							item.sSelect1Name = this.form.table[i]['sSelectName'];
							item.sName1 = this.form.table[i]['sName'];
							item.nSelect1Id = this.form.table[i]['nSelectId'];
						}
						if(this.form.table[i]['sBie'] == item.sBie2) {
							item.sSchema2Name = this.form.table[i]['sSchemaName'];
							item.sSelect2Name = this.form.table[i]['sSelectName'];
							item.sName2 = this.form.table[i]['sName'];
							item.nSelect2Id = this.form.table[i]['nSelectId'];
						}
					}
					getTableRelevanceListBySelectList({
						nSelect1Id: item.nSelect1Id,
						nSelect2Id: item.nSelect2Id
					}).then(res => {
						var arr = [];
						for(var i = 0; i < res.data.length; i++) {
							if(res.data[i]['nSelect1Id'] == item.nSelect1Id && res.data[i]['nSelect2Id'] == item.nSelect2Id) {
								arr.push(res.data[i]);
							} else {
								arr.push({
									nSelect1Id: res.data[i]['nSelect2Id'],
									nSelect1Key: res.data[i]['nSelect2Key'],
									nSelect2Id: res.data[i]['nSelect1Id'],
									nSelect2Key: res.data[i]['nSelect1Key']
								});
							}
						}

						item.keys = arr;
					});
				}
			},
			handleCheckAllChange(item) {
				if(item.checkAll == false) {
					item.value = [];
				} else {
					var arr = [];
					for(var i = 0; i < item.options.length; i++) {
						arr.push(item.options[i]['sColumnCode']);
					}
					item.value = arr;
				}
				item.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				var item = null;
				for(var i = 0; i < this.form.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.form.sSelectFieldName[i]['options'].length; j++) {
						if(value[0] == this.form.sSelectFieldName[i]['options'][j]['sColumnCode']) {
							item = this.form.sSelectFieldName[i];
						}
					}
				}
				//通过value 反查。 在复制
				let checkedCount = value.length;
				if(checkedCount == 0) {
					item.checkAll = false;
					item.isIndeterminate = false;
				} else {
					item.checkAll = checkedCount === item.options.length;
					item.isIndeterminate = checkedCount > 0 && checkedCount < item.options.length;
				}
			},
			arrToString(arr) {
				try {
					return arr.join(',');
				} catch(e) {
					return arr;
				}
			},
			pinjiesql(duoyuarr) {
				var arr = [];
				var displayArr = [];
				for(var i = 0; i < this.form.sSelectFieldName.length; i++) {
					
					for(var j = 0; j < this.form.sSelectFieldName[i]['value'].length; j++) {
						arr.push(
							this.form.sSelectFieldName[i]['sBie'] +
							'.' +
							this.form.sSelectFieldName[i]['value'][j] +
							' as ' +
							this.form.sSelectFieldName[i]['sBie'] +
							'_' +
							this.form.sSelectFieldName[i]['value'][j]
						);
						displayArr.push(this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
					}
				}
				this.sql.ziduan = arr.join(',');

				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				
				var arr = [];
				for(var i = 0; i < this.form.sSelectFilter.length; i++) {
					if(this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.form.sSelectFilter[i]['sBie'] +
							'.' +
							this.form.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.form.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.form.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.form.sSelectFilter[i]['sBie'] +
								'.' +
								this.form.sSelectFilter[i]['sColumnCode'] +
								this.form.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.form.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}
				arr = arr.concat(duoyuarr)
				this.sql.tiaojian = arr.join(' and ');

				var arr = [];
				arr.push(this.form.keys[0]['sSchema1Name'] + '.' + this.form.keys[0]['sSelect1Name'] + ' ' + this.form.keys[0]['sBie1']);

				for(var i = 0; i < this.form.keys.length; i++) {
					var _arr = [];
					for(var j = 0; j < this.form.keys[i]['selectKey'].length; j++) {
						_arr.push(
							this.form.keys[i]['sBie1'] +
							'.' +
							this.stringArr(this.form.keys[i]['selectKey'][j], 0) +
							'=' +
							this.form.keys[i]['sBie2'] +
							'.' +
							this.stringArr(this.form.keys[i]['selectKey'][j], 1)
						);
					}

					arr.push(this.form.keys[i]['sSchema2Name'] + '.' + this.form.keys[i]['sSelect2Name'] + ' ' + this.form.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
				}
				this.sql.table = arr.join(' left join  ');
			},
			addDownLoad() {
				if(this.timer == 0) {
					this.$prompt('Enter file name', 'Tips', {
							confirmButtonText: 'Confirm',
							cancelButtonText: 'Cancel',
							inputPattern: /\S/,
							inputErrorMessage: 'Enter file name'
						})
						.then(({
							value
						}) => {
							addDownloadExport({
								sSchema: this.form.sSchema,
								sSelectName: this.sql.table,
								sSelectFieldName: this.sql.ziduan,
								sSelectFilter: this.sql.tiaojian,
								sFileName: value + '.csv',
								sContent: JSON.stringify(this.form),
								sFavorite: 0,
								nType: 2,
								sStatus: 0
							}).then(res => {
								this.timer = 60;
								var _this = this;
								var T = setInterval(function() {
									_this.timer--;
									if(_this.timer == 1) {
										clearInterval(T);
										setTimeout(function() {
											_this.timer = 0;
										}, 1000);
									}
								}, 1000);
							});
						})
						.catch(() => {});
				}
			}
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// multi.vue?783e4bbc